module.exports = __webpack_public_path__ + "static/media/Asset 2.f95f7ba0.svg";